// ======================================================================
// File Name       : IconConstants
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

export const TOP = 'home';
export const SERVICE = 'star';
export const SYSTEM = 'cog';
export const USER = 'user';
export const FLAG = 'flag';
export const PENCIL = 'pencil';
export const MESSAGE = 'message';
export const MULTI_LANGUAGE = 'globe';
export const GROUP = 'group';
export const CONTENT = 'content';
export const DRILL = 'drill';
export const DRILL_SKIN = 'drillSkin';
export const TAB_QUESTION = 'question';
export const TAB_QUESTION_ACTIVE = 'questionActive';
export const TAB_DRILL = 'contentDrill';
export const TAB_DRILL_ACTIVE = 'contentDrillActive';
export const TAB_VIDEO = 'contentVideo';
export const TAB_VIDEO_ACTIVE = 'contentVideoActive';
export const TAB_LINK = 'contentLink';
export const TAB_LINK_ACTIVE = 'contentLinkActive';
export const TAB_DOCUMENT = 'contentDocument';
export const TAB_DOCUMENT_ACTIVE = 'contentDocumentActive';
export const TAB_RECEIVED_MESSAGE = 'receivedMessage';
export const TAB_RECEIVED_MESSAGE_ACTIVE = 'receivedMessageActive';
export const TAB_SENT_MESSAGE = 'sentMessage';
export const TAB_SENT_MESSAGE_ACTIVE = 'sentMessageActive';
export const TAB_LEARNING_HISTORY_COURSE = 'learningHistoryCourse';
export const TAB_LEARNING_HISTORY_COURSE_ACTIVE = 'learningHistoryCourseActive';
export const TAB_LEARNING_HISTORY_USER = 'learningHistoryUser';
export const TAB_LEARNING_HISTORY_USER_ACTIVE = 'learningHistoryUserActive';
export const TAB_LEARNING_HISTORY_CONTENT = 'learningHistoryContent';
export const TAB_LEARNING_HISTORY_CONTENT_ACTIVE = 'learningHistoryContentActive';
export const TAB_SEND_EMAIL = 'sendEmail';
export const TAB_SEND_EMAIL_ACTIVE = 'sendEmailActive';
export const TAB_RESERVATION_EMAIL = 'reservationEmail';
export const TAB_RESERVATION_EMAIL_ACTIVE = 'reservationEmailActive';
export const RECEIVED_MESSAGE = 'receivedMessage';
export const RECEIVED_MESSAGE_ACTIVE = 'receivedMessageActive';
export const SENT_MESSAGE = 'sentMessage';
export const SENT_MASSAGE_ACTIVE = 'sentMassageActive';
export const EMAIL = 'email';
export const CHAT = 'chat';
export const LIVE = 'live';
export const SCORING = 'scoring';
export const NOTICE = 'notice';
export const SERVICE_RECORD = 'record';
export const TV = 'tv';
export const KEY = 'key';
export const LOGOUT = 'logout';
export const LEARNING = 'learning';
export const AUTHORITY = 'authority';
export const SUB_MENU = 'submenu';
export const REGIST = 'regist';
export const IMPORT = 'import';
export const APPS = 'apps';
export const EDIT = 'edit';
export const ROTATE = 'rotate';
export const ENVELOPE = 'envelope';
export const IMAGE = 'image';
export const APPROVEREPORT = 'approveReport';
export const NONE_ICON = 'noneIcon';
export const COMPANY = 'company';
export const LAYER = 'layer';
export const NOTIFICATION  = 'notification';
export const SYNC = 'sync';
export const LARGE_MENU = [TOP, SERVICE, SYSTEM, USER, FLAG, SCORING, MESSAGE, MULTI_LANGUAGE, GROUP, CONTENT, DRILL];
export const INFORMATION = 'information';
export const CONTACT = 'contact';
export const FAQ = 'faq';
export const REGIST_NEW_ROLE = 'registNewRole';
export const SERVICE_GROUP = 'serviceGroup';
export const ROLE = 'role';
export const ENTERPRISE_SWITCHING = 'enterpriseSwitching';
export const CONTENT_GROUP = 'contentGroup';
export const MAIL_TEMPLATE_USERS = 'mailTemplateUsers';
